import React, { useEffect, useState } from 'react';
import {
  StyledHistoryWrapper,
  StyledParagraph,
  StyledTextLabel,
  StyledTextValueWrapper,
} from '../StyledComponents';
import { FormattedDate } from 'react-intl';
import { Dimensions } from 'components/visuals';
import { removeTimezone } from 'modules/mac/common/utils';

const AccountHistoryItem = ({ period, partnerIds }) => {
  const { partnerName, startDate, orderableItemDescription } = period;

  return (
    <>
      <StyledTextLabel width="auto" textalign="center">
        <FormattedDate
          value={removeTimezone(startDate)}
          day="2-digit"
          month="long"
          year="numeric"
        />
      </StyledTextLabel>
      <p>
        <StyledParagraph padding={`0 ${Dimensions.units(1.25)}px`}>
          {orderableItemDescription}
        </StyledParagraph>
      </p>
      {partnerIds.length > 0 && (
        <StyledTextValueWrapper>
          <p>{partnerName}</p>
        </StyledTextValueWrapper>
      )}
    </>
  );
};

const AccountHistory = ({ accountHistory }) => {
  const [partnerIds, setPartnerIds] = useState<number[]>([]);

  useEffect(() => {
    accountHistory?.periods?.forEach((period) => {
      const { partnerId } = period;
      if (partnerId) setPartnerIds([...partnerIds, partnerId]);
    });
  }, [accountHistory]);

  return (
    <StyledHistoryWrapper data-cy="history-table" dispalyParterName={partnerIds.length > 0}>
      {accountHistory?.periods?.map((period) => (
        <AccountHistoryItem key={period.periodId} period={period} partnerIds={partnerIds} />
      ))}
    </StyledHistoryWrapper>
  );
};

export default AccountHistory;
